export const AdsButton = ({ locationState, channelDragStart, draggedItem }) => {
    return (
        <div className="ads" onDragStart={(e) => channelDragStart(e, draggedItem)} style={{marginTop: '70px'}}>
                <button className="btn btn-danger w-100" data-type="ads" data-duration="00:00:30" data-value={JSON.stringify(locationState?.state?.defaultFiller)} draggable="true">
                + Ads
                </button>
        </div>
    );
};